import { cn } from "@/lib/utils"

const DOT_DELAYS = ["0s", "0.16s", "0.32s"]

/**
 * The three bouncing dots the web widget shows while a reply is being written.
 *
 * `label` announces the wait to assistive tech, which cannot read an animation. Omit it
 * when visible text already says the same thing next to the dots — announcing twice is
 * worse than not at all.
 */
export function TypingIndicator({
  label,
  className,
}: {
  label?: string
  className?: string
}) {
  return (
    <span
      role={label ? "status" : undefined}
      aria-live={label ? "polite" : undefined}
      aria-hidden={label ? undefined : true}
      className={cn("flex items-center gap-1.5", className)}
    >
      {DOT_DELAYS.map((delay) => (
        <span
          key={delay}
          aria-hidden="true"
          style={{ animationDelay: delay }}
          className="h-1.5 w-1.5 animate-typing-bounce rounded-full bg-current motion-reduce:animate-none motion-reduce:opacity-60"
        />
      ))}
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  )
}
